var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-f3", staticStyle: { "min-height": "900px" } },
    [
      _c("div", { staticClass: "f22 fb wrap pad20-t pad15-b" }, [
        _vm._v("订单详情")
      ]),
      _vm.loaded
        ? _c("div", { staticClass: "gray3 wrap" }, [
            _c(
              "div",
              { staticClass: "flex bg-white mar20-b state" },
              [
                _c("div", { staticClass: "text-center left" }, [
                  _vm.dataMasking
                    ? _c("div", { staticClass: "pad25-t pad30-b" }, [
                        _vm._v("订单编号：****")
                      ])
                    : _c("div", { staticClass: "pad25-t pad30-b" }, [
                        _vm._v("订单编号：" + _vm._s(_vm.detail.orderId))
                      ]),
                  _c(
                    "div",
                    {
                      staticClass: "fb pad50-b f26",
                      staticStyle: { color: "#71b247" }
                    },
                    [_vm._v(_vm._s(_vm.detail.orderStCn))]
                  ),
                  _c("div", {
                    staticClass:
                      "pad40-b flex flex-wrap text-center flex-item1 pad20-lr btn-group"
                  })
                ]),
                _c("order_info_dtl", { attrs: { detail: _vm.detail } })
              ],
              1
            ),
            !_vm.dataMasking
              ? _c("div", { staticClass: "bg-white f14 pad20" }, [
                  _c("div", { staticClass: "pad20 mar20-b border" }, [
                    _vm.showContractButton
                      ? _c("div", { staticClass: "flex mar10-tb mar40-r" }, [
                          _c("div", { staticClass: "nowrap pad10-r" }, [
                            _vm._v("订单合同：")
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex-auto flex flex-wrap" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: { click: _vm.viewContract }
                                },
                                [_vm._v(_vm._s(_vm.orderId))]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm.detail.electronicSend && _vm.detail.electronicSend[0]
                      ? _c("div", { staticClass: "flex mar10-tb" }, [
                          _c("div", { staticClass: "nowrap pad10-r" }, [
                            _vm._v("发货单：")
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex-auto flex flex-wrap" },
                            _vm._l(_vm.detail.electronicSend, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.contractSignNum,
                                  staticClass: "pad20-r blue pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.contractPreviewHandle(
                                        item.contractSignNum
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.contractSignNum) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm.detail.electronicReceipt &&
                    _vm.detail.electronicReceipt[0]
                      ? _c("div", { staticClass: "flex mar10-tb" }, [
                          _c("div", { staticClass: "nowrap pad10-r" }, [
                            _vm._v("收货单：")
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex-auto flex flex-wrap" },
                            _vm._l(_vm.detail.electronicReceipt, function(
                              item
                            ) {
                              return _c(
                                "div",
                                {
                                  key: item.contractSignNum,
                                  staticClass: "pad20-r blue pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.contractPreviewHandle(
                                        item.contractSignNum
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.contractSignNum) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm.detail.noticeOrderContractSignNum
                      ? _c("div", { staticClass: "flex mar10-tb mar40-r" }, [
                          _c("div", { staticClass: "nowrap pad10-r" }, [
                            _vm._v("电子提货通知单：")
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex-auto flex flex-wrap" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "blue pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.contractPreviewHandle(
                                        _vm.detail.noticeOrderContractSignNum
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.detail.noticeOrderContractSignNum
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "bg-white f14 pad20" },
              [
                _c("logistics_dtl", {
                  attrs: {
                    orderDelivery: _vm.orderDelivery,
                    goodsPic: _vm.orderGoodsList[0].goodsPic,
                    dataMasking: _vm.dataMasking
                  }
                }),
                _c("order_basic_info_dtl", {
                  attrs: { detail: _vm.detail, dataMasking: _vm.dataMasking }
                }),
                _vm.detail.delivery == "2"
                  ? _c(
                      "div",
                      { staticClass: "pad20 mar20-b border" },
                      [
                        _vm._m(0),
                        _vm.detail.orderDtlBo.orderSellVehicleList.length > 0
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.detail.orderDtlBo.orderSellVehicleList,
                                function(vehicle) {
                                  return _c(
                                    "div",
                                    {
                                      key: vehicle.id,
                                      staticClass: "flex f14 flex-item1"
                                    },
                                    [
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("车牌号:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.licensePlateNum.replace(
                                                          /^(.{1}).+(.)/,
                                                          "$1**$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.licensePlateNum
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("司机:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.name.substring(
                                                          0,
                                                          1
                                                        ) +
                                                          new Array(
                                                            vehicle.name.length
                                                          ).join("*")
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [_vm._v(_vm._s(vehicle.name))]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("联系方式:")]
                                            ),
                                            _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.tel.replace(
                                                          /^(.{3})(?:\d+)(.{4})$/,
                                                          "$1****$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mar10-l mar50-r"
                                                  },
                                                  [_vm._v(_vm._s(vehicle.tel))]
                                                )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "item" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex mar10-b" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "gray6" },
                                              [_vm._v("身份证号:")]
                                            ),
                                            vehicle.idCard && _vm.dataMasking
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        vehicle.idCard.replace(
                                                          /^(.{4})(?:\d+)(.{4})$/,
                                                          "$1******$2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "mar10-l" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(vehicle.idCard)
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]),
                                      _vm._m(1, true)
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._l(
                          _vm.detail.orderDtlBo.orderBuyerVehicleList,
                          function(vehicle) {
                            return _c(
                              "div",
                              {
                                key: vehicle.id,
                                staticClass: "flex f14 flex-item1"
                              },
                              [
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("车牌号:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.licensePlateNum.replace(
                                                /^(.{1}).+(.)/,
                                                "$1**$2"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(vehicle.licensePlateNum)
                                          )
                                        ])
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("司机:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.name.substring(0, 1) +
                                                new Array(
                                                  vehicle.name.length
                                                ).join("*")
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(_vm._s(vehicle.name))
                                        ])
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("联系方式:")
                                    ]),
                                    _vm.dataMasking
                                      ? _c(
                                          "div",
                                          { staticClass: "mar10-l mar50-r" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                vehicle.tel.replace(
                                                  /^(.{3})(?:\d+)(.{4})$/,
                                                  "$1****$2"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "mar10-l mar50-r" },
                                          [_vm._v(_vm._s(vehicle.tel))]
                                        )
                                  ])
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "flex mar10-b" }, [
                                    _c("div", { staticClass: "gray6" }, [
                                      _vm._v("身份证号:")
                                    ]),
                                    vehicle.idCard && _vm.dataMasking
                                      ? _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(
                                            _vm._s(
                                              vehicle.idCard.replace(
                                                /^(.{4})(?:\d+)(.{4})$/,
                                                "$1******$2"
                                              )
                                            )
                                          )
                                        ])
                                      : _c("div", { staticClass: "mar10-l" }, [
                                          _vm._v(_vm._s(vehicle.idCard))
                                        ])
                                  ])
                                ]),
                                _vm._m(2, true)
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                !_vm.dataMasking &&
                _vm.detail.voucherPicMapList &&
                _vm.detail.voucherPicMapList.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "pad20 flex flex-item1 mar20-b flex-item1 border certificate"
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "f16 fb mar15-b" }, [
                            _vm._v("订单凭证")
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "relative certificate",
                              staticStyle: {
                                height: "270px",
                                "overflow-y": "auto"
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "line",
                                staticStyle: { bottom: "84px" }
                              }),
                              _vm._l(_vm.detail.voucherPicMapList, function(
                                voucherMap
                              ) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center mar5-r"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "radius20 z-index2 ball"
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "mar10-l" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  voucherMap.voucherType ==
                                                    "SELLER"
                                                    ? "卖家"
                                                    : "买家"
                                                ) +
                                                  " " +
                                                  _vm._s(voucherMap.boIdName) +
                                                  " " +
                                                  _vm._s(voucherMap.boIdPhone)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("div", { staticClass: "gray9" }, [
                                        _vm._v(_vm._s(voucherMap.creationDate))
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex mar10-t mar20-b mar19-l flex-wrap"
                                    },
                                    _vm._l(voucherMap.voucherPicList, function(
                                      vouche,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "wh64 radius4 mar5-r relative overflow"
                                        },
                                        [
                                          !_vm.isZip(vouche.url)
                                            ? _c("el-image", {
                                                attrs: {
                                                  src:
                                                    vouche.url +
                                                    "?imageView2/1/w/80/h/80",
                                                  "preview-src-list": voucherMap.voucherPicList.map(
                                                    function(item) {
                                                      return item.url
                                                    }
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          _vm.isZip(vouche.url)
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "line-height": "64px",
                                                    display: "block",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: vouche.url
                                                      }
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        attrs: {
                                                          src:
                                                            "https://files.nxin.com/mobile/public/zip.png"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ]
                              })
                            ],
                            2
                          ),
                          _vm.detail.takeGoodsNum != ""
                            ? _c(
                                "div",
                                { staticClass: "flex mar40-t items-center" },
                                [
                                  _c("div", [_vm._v("提货单号：")]),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.detail.takeGoodsNum))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e(),
                _c("order_goods_info_dtl", {
                  attrs: {
                    orderGoodsList: _vm.orderGoodsList,
                    orderGoodsGiftBoList: _vm.orderGoodsGiftBoList,
                    dataMasking: _vm.dataMasking
                  }
                }),
                !_vm.dataMasking
                  ? _c("order_pay_info_dtl", { attrs: { detail: _vm.detail } })
                  : _vm._e()
              ],
              1
            )
          ])
        : _c("div", { staticStyle: { "min-height": "900px" } }),
      _c("contract_sign", {
        ref: "contract_sign_dialog",
        attrs: { order: _vm.detail },
        on: { loadOrder: _vm.loadOrder }
      }),
      _c("contractPreview", {
        attrs: {
          url: _vm.contractPreviewUrl,
          visible: _vm.contractPreviewVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.contractPreviewVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center mar15-b" }, [
      _c("div", { staticClass: "f16 gray3 flex-auto fb" }, [
        _vm._v("自提车辆信息")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "flex mar10-b" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }